module.exports = __webpack_public_path__ + "img/sr.46314580.svg";